import { Component, inject, signal } from '@angular/core';
import { UserOfferDetailsComponent } from '../../../../components/user-dashboard-component/user-offer-details-component/user-offer-details-component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-bundle-details',
  imports: [UserOfferDetailsComponent],
  templateUrl: './user-bundle-details.html',
  styleUrl: './user-bundle-details.scss',
})
export class UserBundleDetails {
  private route = inject(ActivatedRoute);
  bundleId = signal('');
  ngOnInit() {
    const bundleId = this.route.snapshot.params['id'];
    this.bundleId.set(bundleId);
  }
}
